<div class="selector">
  <fa-icon [icon]="['far', 'language']"></fa-icon>
  <div class="opt" *ngFor="let l of languageList" (click)="changeLanguage(l)">
    {{ l.name }}
  </div>
</div>
